import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest
  const [wishlist, setWishlist] = useState([]);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setWishlist(data.wishlist || []);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sharoa_token", data.token);
    await loadMe();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("sharoa_token", data.token);
    await loadMe();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("sharoa_token");
    setUser(false);
    setWishlist([]);
  };

  const toggleWishlist = async (productId) => {
    if (!user) { toast("Please sign in to save favourites ♡"); return false; }
    try {
      const { data } = await api.post("/wishlist/toggle", { product_id: productId });
      setWishlist(data.wishlist);
      toast(data.active ? "Added to Wishlist ♡" : "Removed from Wishlist");
      return data.active;
    } catch (e) { toast.error(apiErr(e)); return false; }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, wishlist, login, register, logout, toggleWishlist, loadMe, isAdmin: user && user.role && user.role !== "customer" }}>
      {children}
    </AuthContext.Provider>
  );
}
